import React from "react";
import "./BillingDetailCard.css";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { titles } from "constants/titles";
import { convertToShortDate } from "utility";
import { CardIcon } from "assets/SVGs/SVGs";
import { useSelector } from "react-redux";

const BillingDetailCard = ({
  totalAmount,
  invoiceItem,
  onEditBillingDetails,
  onPayment,
}) => {

  const { medicalUserDetail } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const { cardDetails, bankDetails, } = useSelector(
    (store) => store?.payments
  );

  const hasPaymentDetail = () => {
    const hasBankDetails = medicalUserDetail?.payment_method_type === "bank" && bankDetails;
    const hasCardDetails = cardDetails && cardDetails !== null;
    const hasAnyPaymentMethod = medicalUserDetail?.payment_method_type &&
      (medicalUserDetail?.payment_method_type === "bank" || medicalUserDetail?.payment_method_type === "card");
    return hasBankDetails || hasCardDetails || hasAnyPaymentMethod;
  };

  return (
    <div className="billing_detail_card">
      <div className="billing_detail_header">
        <div className="billing_detail_icon_container">
          <CardIcon className="billing_detail_icon" />
        </div>
      </div>

      <div className="billing_detail_content">
        <div className="billing_detail_amount">
          ${totalAmount?.toFixed(2)}
        </div>
        {invoiceItem && (invoiceItem?.invoice_due_date || invoiceItem?.due_date) && (
          <div className="billing_detail_due_date">
            Due {convertToShortDate(invoiceItem?.invoice_due_date || invoiceItem?.due_date)}
          </div>
        )}

        <div className="billing_detail_separator"></div>

        <div className="billing_detail_description">
          {titles?.update_payment_discription}
        </div>

        {/* Primary action: Pay Now */}
        {hasPaymentDetail() ?
          <CustomButton
            text={titles?.pay_now}
            width="100%"
            className="billing_detail_pay_button"
            onClick={onPayment}
          />
          : null}
        <CustomButton
          text={hasPaymentDetail() ? (titles?.edit_billing_info) : `+ ${titles?.add_new_payment_info}`}
          width="100%"
          className="billing_detail_edit_button"
          onClick={onEditBillingDetails}
        />
      </div>
    </div>
  );
};

export default BillingDetailCard;
